import React from 'react';
import { Button, Col, EditableInfoComponent, Row, Typography } from 'components';
import { LatestStatisticsIcon, OutlineArrowDownIcon, OutlineArrowUpIcon } from 'components/common/icons';
import styles from 'feature/supplierTabs/shipping/shippingRates/styles.module.scss';
import { SHIPPING_MEASUREMENT_RANGE_MAPPING, SHIPPING_RATE_METRICS_MAPPING } from 'staticData/form/client/shipping';
import { useLatestStatistics } from 'feature/supplierTabs/shipping/latestStatistics/useLatestStatistics';

const { Text } = Typography;

interface IPrice {
  metrics: string;
  measurementRange: string;
  price: number;
}

export const LatestStatistics = React.memo(() => {
  const { data, priceList, onShowAllStateChange, isSeeAllVisible, isAllShown } = useLatestStatistics();
  const { leadTimeMin, leadTimeMax, type, orderFulfillmentTime, onTimeDeliveryRate, damageAndLossRate } = data;
  return (
    <Row>
      <EditableInfoComponent
        icon={<LatestStatisticsIcon />}
        title={'Latest Statistics'}
        editable={false}
        creatable={false}
      />
      <Col span={24}>
        <Row gutter={[0, 4]}>
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  Lead Time
                </Text>
              </Col>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  {leadTimeMin && leadTimeMax
                    ? `${leadTimeMin}-${leadTimeMax} ${type === 'DAY' ? 'days' : 'weeks'}`
                    : leadTimeMin
                      ? `${leadTimeMin} Min`
                      : leadTimeMax
                        ? `${leadTimeMax} Max`
                        : 'Not Set'}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  Order Fulfillment Time
                </Text>
              </Col>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  {orderFulfillmentTime ? `${orderFulfillmentTime}%` : 'Not Set'}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  On-Time Delivery Rate
                </Text>
              </Col>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  {onTimeDeliveryRate ? `${onTimeDeliveryRate}%` : 'Not Set'}
                </Text>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  Damage and Loss Rate
                </Text>
              </Col>
              <Col>
                <Text type={'secondary'} className={'font-size-16'}>
                  {damageAndLossRate ? `${damageAndLossRate}%` : 'Not Set'}
                </Text>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {!!priceList?.length && (
        <Col span={24} className={'margin-t-16'}>
          <Row>
            <Col span={24}>
              <Text className={'font-weight-600'}>Price</Text>
            </Col>
            <Col span={24}>
              {priceList.map((price: IPrice, index: number) => {
                return (
                  <Row className={styles.shipping_rate_price} key={index} justify={'space-between'}>
                    <Col>
                      <Text type={'secondary'}>
                        {SHIPPING_RATE_METRICS_MAPPING[price.metrics]}:{' '}
                        {SHIPPING_MEASUREMENT_RANGE_MAPPING[price.measurementRange]}
                      </Text>
                    </Col>
                    <Col>
                      {price.price && (
                        <Text type={'secondary'} className={'font-weight-500'}>
                          {price.price} €
                        </Text>
                      )}
                    </Col>
                  </Row>
                );
              })}
            </Col>
            {isSeeAllVisible && (
              <Col span={24}>
                <Row align={'middle'} justify={'end'}>
                  <Col>
                    <Button
                      type={'link'}
                      variant={'link'}
                      style={{
                        color: '#308D82',
                        textDecoration: 'underline',
                        padding: 0,
                        margin: 0,
                        fontSize: 14,
                        fontWeight: 400,
                      }}
                      onClick={onShowAllStateChange}
                    >
                      {isAllShown ? 'See Less' : 'See All'}
                      {isAllShown ? (
                        <OutlineArrowUpIcon size={'sm'} color={'#308D82'} />
                      ) : (
                        <OutlineArrowDownIcon size={'sm'} color={'#308D82'} />
                      )}
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Col>
      )}
    </Row>
  );
});
